
import flexibleWorkingHours from 'images/careers/flexible-working-hours.svg';
import goodWeapons from 'images/careers/good-weapons.svg';
import bullshitFree from 'images/careers/bullshit-free.svg';
import goodSnacks from 'images/careers/good-snacks.svg';
import intergalacticTeam from 'images/careers/intergalactic-team.svg';
import relocationOpportunity from 'images/careers/relocation-opportunity.svg';
import multisport from 'images/careers/multisport.svg';
import fridayDinners from 'images/careers/friday-dinners.svg';


export default {
  header: {
    title: 'Our philosophy',
    description: "At Iterio Data we value technical knowledge and effectiveness above all else.  We're looking for engineers with authentic personalities who love to learn new skills and apply them.  If you have the drive to build great products and understand data then get in touch with us. \n We'll help you grow your career in a meaningful way.",
  },
  contentBlocks: {
    perks: {
      title: 'Perks & benefits',
      blocks: [{
        title: 'Flexible schedule',
        description: 'Both early birds and night owls are welcome. We also accommodate periodic remote work.',
        icon: flexibleWorkingHours,
      }, {
        title: 'Good weapons',
        description: 'Macbooks and 4k monitors are our standard. But we’re happy to provide whatever equipment you need to get the job done.',
        icon: goodWeapons,
      }, {
        title: 'Bullshit free workspace',
        description: "Can't deal with bureaucracy and office politics? Great. We value code not talk.",
        icon: bullshitFree,
      }, {
        title: 'Good grub',
        description: 'After code, food is our second love. So we supply snacks and drinks.',
        icon: goodSnacks,
      }, {
        title: 'Intergalactic team',
        description: 'Expand your worldview by working with clients and teammates in San Francisco, New York, Miami, and Moscow.',
        icon: intergalacticTeam,
      }, {
        title: 'Relocation opportunity',
        description: 'Do you want to move to San Francisco or Kraków? Let us know and we’ll help out',
        icon: relocationOpportunity,
      }, {
        title: 'Multisport cards',
        description: 'We care about our people’s health. Grab a free pass to the best gyms & sport clubs.',
        icon: multisport,
      }, {
        title: 'Friday dinners',
        description: 'Every week we share a meal together. This is our oldest and most important company tradition.',
        icon: fridayDinners,
      }],
    },
    offers: {
      title: 'Open positions',
      blocks: [{
        url: 'data_engineer',
        title: 'Data Engineer',
        locations: [
          'San Francisco, California',
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Work on a high traffic data pipeline to collect, store, and analyze billions of events',
          'Develop data warehouses on Amazon Web Services and Google Cloud Platform',
          'Manage data sources and build ETL processes using APIs from multiple companies',
          'Lead projects to create new datasets for data scientists and business analysts',
          'Work closely with developers to collect metrics from their applications',
          'Setup and maintain database replication processes',
        ],
        requirements: [
          'Fluent English',
          'A minimum of 1-year of industry experience in a similar role',
          'Understand how to use Git, preferably using the command-line',
          'Experience with a scripting language such as Python',
          'Advanced knowledge of SQL and relational databases',
          'Experience with database performance optimization',
          'Experience working with and integrating third-party APIs',
          'Basic command-line skills and bash scripting',
        ],
        impressUs: [
          'Ability to perform effective data analysis',
          'Experience with ETL (extract, transform, load) processes',
          'Track record of building production-grade systems that are stable, resilient, and performant',
          'Experience with Amazon Web Services, specifically Redshift and Elastic MapReduce',
          'Experience processing large datasets using platforms such as Hadoop and Spark',
          'Knowledge of systems architecture, specifically distributed databases',
          'Experience working with and integrating third-party APIs',
          'Strong computer science fundamentals',
        ],
      }, {
        url: 'data_scientist',
        title: 'Data Scientist',
        locations: [
          'San Francisco, California',
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Build statistical and machine learning algorithms that drive business decisions',
          'Measure and predict KPIs related to user acquisition and retention',
          'Improve upon our existing reporting strategies to communicate ongoing performance',
          'Provide various teams with ad-hoc analysis to aide day-to-day operations',
          'Influence product decisions through quantifiable goals',
          'Lead projects for customer segmentation, personalization, and pricing',
          'Identify opportunities for developing new data sources',
        ],
        requirements: [
          'Fluent English',
          'Bachelor’s degree or higher in statistics, computer science, or other quantitative discipline',
          'Understand how to use Git',
          'Advanced SQL skills',
          'Experience with a language suitable for data analysis such as Python, Java, or R',
          'Fluency in data analysis and communication about data',
          'Basic command-line skills and bash scripting',
        ],
        impressUs: [
          'Knowledge of recommender systems',
          'Experience with customer retention modeling and/or survival analysis',
          'A/B testing experience',
          'Experience with Amazon Web Services or Google Cloud Platform',
          'Experience processing large datasets using platforms such as Hadoop and Spark',
          'Strong computer science fundamentals',
        ],
      }, {
        url: 'data_analyst',
        title: 'Data Analyst',
        locations: [
          'San Francisco, California',
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Build data models that drive business decisions',
          'Ensure data integrity across various reports and dashboards',
          'Measure and predict KPIs related to user acquisition and retention',
          'Improve upon our existing reporting strategies to communicate ongoing performance',
          'Provide product teams with ad-hoc analysis to aide day-to-day operations',
        ],
        requirements: [
          'Fluent English',
          'Bachelor’s degree or higher in statistics, finance, economics, or other quantitative discipline',
          'Extensive experience with Excel or Google Sheets',
          'Advanced SQL skills',
          'Strong business acumen',
          'Fluency in data analysis and communication about data',
        ],
        impressUs: [
          'Experience with BI tools such as Tableau, Looker, Splunk, etc',
          'Knowledge of customer retention modeling and/or survival analysis',
          'A/B testing experience',
          'Experience with a language suitable for data analysis such as Python, Java, or R',
          'Experience with Amazon Web Services or Google Cloud Platform',
        ],
      }, {
        url: 'devops_engineer',
        title: 'DevOps Engineer',
        locations: [
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Develop deployment process for multiple servers and software components',
          'Migrate production applications and databases to AWS',
          'Setup detailed metrics and alarms for servers and applications',
          'Develop and test procedures for scaling app servers and databases',
          'Setup and monitor database replication processes',
          'Develop and test restore/recovery procedures for handling system failures',
        ],
        requirements: [
          'Fluent English',
          'A minimum of 1-year of industry experience in a similar role',
          'Understand how to use Git using the command line',
          'Experience with a scripting language such as Python or PHP',
          'Strong command-line skills and bash scripting',
          'Experience with relational databases',
          'Working knowledge of Amazon Web Services or Google Cloud Platform',
          'Experience configuring web servers such as Nginx',
          'Working knowledge of at least one devops tool such as Ansible, Chef, Puppet, etc',
        ],
        impressUs: [
          'Extensive experience with deployment processes',
          'Strong knowledge of best practices for database migrations',
          'Experience with unit tests, integration tests, or code reviews',
        ],
      }, {
        url: 'javascript_developer',
        title: 'JavaScript Developer',
        locations: [
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Write clean and maintainable code',
          'Build our next generation product features using modern JavaScript frameworks',
          'Design and develop innovative data visualizations',
          'Diagnose and resolve client-side performance issues',
          'Own a feature in the first 30 days',
          'Work closely with analysts and data scientists to collect metrics from the applications',
          'Contribute to the continual improvement of our design and development process',
        ],
        requirements: [
          'Fluent English',
          'A minimum of 1-year of industry experience in a similar role',
          'Understand how to use Git',
          'Strong knowledge of core JavaScript',
          'Thorough and recent experience with HTML and CSS',
          'Experience with responsive layouts and coding for all screens',
          'Experience with at least one front-end JavaScript framework such as React or Backbone',
          'Experience with build tools (gulp, grunt, etc)',
          'Comfortable working in a UNIX branch and basic command line proficiency',
        ],
        impressUs: [
          'Experience with backend development using Node.js or Python',
          'Experience working on large projects with multiple developers',
          'Experience with Amazon Web Services or Google Cloud Platform',
          'Experience with unit tests, integration tests, and code reviews',
          'Strong computer science fundamentals',
        ],
      }, {
        url: 'python_developer',
        title: 'Python Developer',
        locations: [
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Write clean and maintainable code',
          'Own a feature in the first 30 days',
          'Work with high traffic production systems',
          'Build our next generation product features using Python',
          'Manage data sources and build ETL processes using APIs from multiple companies',
          'Build data access APIs used by our clients and frontend developers',
          'Monitor a production data pipeline and resolve performance bottlenecks',
          'Work closely with analysts and data scientists to collect metrics from applications',
          'Contribute to the continual improvement of our design and development process',
        ],
        requirements: [
          'Fluent English',
          'A minimum of 1-year of industry experience in a similar role',
          'Understand how to use Git, preferably using the command-line',
          'Experience working with and integrating third-party APIs',
          'Experience configuring web servers such as Nginx',
          'Experience with relational databases such as Postgresql',
          'Familiar with best practices for REST API design and basics of the HTTP protocol',
          'Basic command-line skills and bash scripting',
          'Ability to identify and resolve performance bottlenecks',
        ],
        impressUs: [
          'Ability to work with a large codebase and iteratively refactor it into easily testable and easily maintainable Python code.',
          'Familiarity with monitoring tools like Prometheus and opinions on how best to monitor Python applications',
          'Basic experience with Node.js or other JavaScript development',
          'Familiarity with Amazon Web Services or Google Cloud Platform',
          'Ability to develop meaningful tests with frameworks like pytest, nose, etc',
          'Strong computer science fundamentals',
        ],
      }, {
        url: 'ux_designer',
        title: 'UX Designer',
        locations: [
          'San Francisco, California',
          'Kraków, Małopolskie, Poland',
        ],
        compensation: 'Depends on experience',
        dailyTasks: [
          'Evolve our overall design style and user experience vision for our users',
          'Brainstorming, sketching, wireframing/flow creation, final visuals, prototyping and asset creation',
          'Incorporate data and user feedback into your designs',
          'Perform usability research on features and communicate findings to the company',
          'QA your designs thoroughly to ensure we ship a high quality product',
        ],
        requirements: [
          'Fluent English',
          'Minimum of 1-year of design experience and shipping products',
          'A desire and passion to build successful products',
          'Experience designing for mobile-web, desktop-web, and mobile-apps',
          'Experience with tools such as Sketch and Photoshop',
          'An online or on-request portfolio demonstrating your process and final designs',
        ],
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/careers.js